// extracted by mini-css-extract-plugin
export default {"box":"_404_box_ZSYg2","title":"_404_title_E12Rj"};